// Helper methods for assessing user access

export const isSuperAdmin = (user) => {
  return user && user.userClass === 'golfstatus_super_admin';
};

export const isAdmin = (user) => {
  return user && user.userClass === 'golfstatus';
};

export const isGolfStatus = (user) => {
  return isAdmin(user) || isSuperAdmin(user);
};

export const isOrganizationOwner = (user, organization) => {
  if (isGolfStatus(user)) {
    return true;
  }
  if (!user || !organization || user?.organizationUsers?.length === 0) {
    return false;
  }
  const organizationUser = user?.organizationUsers?.find(
    (ou) => [ou.organization.id, ...ou.organizationChildrenIds].includes(organization.id)
  );
  return organizationUser && organizationUser.role === 'owner';
};

export const isOrganizationMember = (user, organization) => {
  if (isGolfStatus(user)) {
    return true;
  }
  if (!user || !organization || user?.organizationUsers?.length === 0) {
    return false;
  }
  const organizationUser = user?.organizationUsers?.find(
    (ou) => [ou.organization.id, ...ou.organizationChildrenIds].includes(organization.id)
  );
  return organizationUser && organizationUser.role === 'member';
};

export const isTournamentOrganizer = (user, organization) => {
  if (isGolfStatus(user)) {
    return true;
  }
  if (!user || !organization || user?.organizationUsers?.length === 0) {
    return false;
  }
  const organizationUser = user?.organizationUsers?.find(
    (ou) => [ou.organization.id, ...ou.organizationChildrenIds].includes(organization.id)
  );
  return organizationUser && organizationUser.role === 'tournament_organizer';
};

export const isOrganizationUser = (user, organization) => {
  if (isGolfStatus(user)) {
    return true;
  }
  if (!user || !organization || user?.organizationUsers?.length === 0) {
    return false;
  }
  return (
    user.organizationUsers?.find(
      (ou) => [ou.organization.id, ...ou.organizationChildrenIds].includes(organization.id)
    ) !== undefined
  );
};

export const hasMemberAccess = (user, organization) => {
  return (
    isOrganizationOwner(user, organization) ||
    isOrganizationMember(user, organization)
  );
};
